// src/icons/svgs/dropdown-icon.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgDropdownIcon = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 6, fill: "none", viewBox: "0 0 10 6", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "#343A40", d: "M5.222 5.555.604.222H9.84z" }) });
var ForwardRef = forwardRef(SvgDropdownIcon);
var dropdown_icon_default = ForwardRef;
export {
  dropdown_icon_default as DropdownArrow
};
